import React, {
  useContext,
  useImperativeHandle,
  forwardRef,
  useState,
} from "react";
import { PropagateLoader, ScaleLoader } from "react-spinners";
import loaderContext from "../../context/loader/LoaderContext";

const TopLoader = () => {
  const {
    ref,
    loaderRunning,
    setLoaderRunning,
    loaderAnnotationRunning,
  } = useContext(loaderContext);

  const [localLoading, setLocalLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    continuousStart() {
      setLocalLoading(true);
      setLoaderRunning(true);
    },
    complete() {
      setLocalLoading(false);
      setLoaderRunning(false);
    },
  }));

  if (!loaderRunning) return null;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        zIndex: "999999999999",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        opacity: loaderAnnotationRunning ? "0" : "0.8",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      {localLoading && <PropagateLoader color="#0078d4"  speedMultiplier={1} />}
    </div>
  );
};

export default forwardRef(TopLoader);